import * as React from 'react';
import { useTranslation } from 'react-i18next';
import { Footer } from '../../../moleculesLegacy/Footer';
import CustomHeader from '../../CustomHeader';
import ProgressBar from '../../ProgressBar';
import ResponsiveContainer from '../../ResponsiveContainer';
import {
  CustomHeaderContainer,
  PublicReportingContainer,
  QuestionHeader,
  QuestionHeaderContainer,
} from './QuestionContainer.styles';
import type { TranslationKey } from 'src/types';

interface QuestionContainerProps {
  organisation: string;
  backLink: string;
  nextLink: string;
  submitAnswer: () => void;
  requireAnswer?: boolean;
  textFieldValue?: string;
  i18nHeader: TranslationKey;
  percentage: number;
  nextLinkDisabled?: boolean;
  setMinHeight?: boolean;
  children?: React.ReactNode;
}

export const QuestionContainer: React.FC<QuestionContainerProps> = (props) => {
  const { t } = useTranslation();
  const disableNext =
    (props.textFieldValue === '' && props.requireAnswer) ||
    props.nextLinkDisabled;

  return (
    <PublicReportingContainer>
      <CustomHeaderContainer>
        <CustomHeader organisation={props.organisation} />
      </CustomHeaderContainer>

      <ResponsiveContainer
        includeLeftCircleButton={true}
        includeRightCircleButton={true}
        includeBottomButton={true}
        backLinkTo={`/${props.organisation}/open-reporting/${props.backLink}`}
        nextLinkTo={`/${props.organisation}/open-reporting/${props.nextLink}`}
        nextLinkDisabled={disableNext}
        nextButtonOnClick={props.submitAnswer}
        backButtonOnClick={props.submitAnswer}
        buttonText={t('Buttons.next')}
        buttonStyles={{ textTransform: 'uppercase' }}
        setMinHeight={props.setMinHeight}
      >
        <QuestionHeaderContainer>
          <QuestionHeader>{t(props.i18nHeader)}</QuestionHeader>
          <ProgressBar percentage={props.percentage} />
        </QuestionHeaderContainer>

        {props.children}
      </ResponsiveContainer>

      <Footer id="desktop-powered-by-vault" />
    </PublicReportingContainer>
  );
};

export default QuestionContainer;
